<template src="../templates/normal_fcont_128.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '128',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,InfoMachineTranslation,
    AppDownloadiPrint
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['128-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['128-2']}
    ]};
  }
  
};
</script>
<style >
</style>

